import { objectImageElements } from "@/elements";
import ObjectImage from "@/modules/ObjectImage"

if (document.getElementById(objectImageElements.id)) {
    ObjectImage.init()
}